import React from "react";
import { NavLink } from "react-router-dom";
import {
  FaInstagram,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaGithub,
} from "react-icons/fa";

function Footer() {
  return (
    <footer className=" bg-cyan-900 pb-12 pt-24">
      <div className="container">
        <div className="w-full">
          <h2 className="mb-6 px-4 text-xl font-bold text-white">HADI 🧑‍💻</h2>
          <div className="flex flex-wrap ">
            <div className="mb-12 w-full px-4 text-slate-100 md:w-1/3">
              <h3 className="mb-4 text-lg font-semibold md:text-xl">Contact</h3>
              <p className="mb-1 text-sm md:mb-2">khairelhadi0@gmail.com</p>
              <p className="mb-1 text-sm md:mb-2">IG: @dyy_rul07</p>
              <p className="mb-1 text-sm md:mb-2">Yogyakarta</p>
            </div>
            <div className="mb-12 w-full px-4 text-slate-100 md:w-1/3">
              <h3 className="mb-4 text-lg font-semibold">Link 👇</h3>
              <ul>
                <li>
                  <a
                    href="/#about"
                    className="mb-1 inline-block text-sm hover:text-primary md:mb-2"
                  >
                    about
                  </a>
                </li>
                <li>
                  <a
                    href="/#quote"
                    className="mb-1 inline-block text-sm hover:text-primary md:mb-2"
                  >
                    Quote
                  </a>
                </li>
                <li>
                  <a
                    href="/#contact"
                    className="mb-1 inline-block text-sm hover:text-primary md:mb-2"
                  >
                    Contact
                  </a>
                </li>
                <li>
                  <a
                    href="/#blog"
                    className="mb-1 inline-block text-sm hover:text-primary md:mb-2"
                  >
                    Blog
                  </a>
                </li>
                <li>
                  <a
                    href="/#blog"
                    className="mb-1 inline-block text-sm hover:text-primary md:mb-2"
                  >
                    Project
                  </a>
                </li>
              </ul>
            </div>
            <div className="mb-12 w-full px-4 text-slate-100 md:mb-2 md:w-1/3">
              <h3 className="mb-4 text-lg font-semibold">Article 📝</h3>
              <ul>
                <li>
                  <NavLink
                    to="/artikel1"
                    className="mb-1 inline-block text-sm hover:text-primary md:mb-2"
                  >
                    Mastering Programming
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/artikel2"
                    className="mb-1 inline-block text-sm hover:text-primary md:mb-2"
                  >
                    Error Handling
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/artikel3"
                    className="mb-1 inline-block text-sm hover:text-primary md:mb-2"
                  >
                    Popular Frameworks
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div className="text-auto mx-auto mb-5 mt-5  max-w-full text-center">
            <p className="mb-2 text-xs text-slate-300  md:text-sm">
              Check Out My
            </p>
            <div className="mx-auto flex justify-center">
              <div className=" items-center p-4 ">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://instagram.com/dyy_rul07?igshid=YmMyMTA2M2Y="
                >
                  <FaInstagram
                    size={18}
                    className="mx-auto text-slate-100 transition duration-300 hover:-translate-y-1 hover:text-orange-500"
                  />
                </a>
              </div>
              <div className=" items-center p-4">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.facebook.com/profile.php?id=100078541170035&mibextid=ZbWKwL"
                >
                  <FaFacebook
                    size={18}
                    className="mx-auto  text-slate-100 transition duration-300 hover:-translate-y-1 hover:text-orange-500"
                  />
                </a>
              </div>
              <div className=" items-center p-4">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://twitter.com/ElhadiKhair?t=tuXc8rDOhZSmBBP90kIgnA&s=09"
                >
                  <FaTwitter
                    size={18}
                    className="mx-auto  text-slate-100 transition duration-300 hover:-translate-y-1 hover:text-orange-500"
                  />
                </a>
              </div>
              <div className=" items-center p-4">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.linkedin.com/in/khairul-hadi-a51598222"
                >
                  <FaLinkedin
                    size={18}
                    className="mx-auto  text-slate-100 transition duration-300 hover:-translate-y-1 hover:text-orange-500"
                  />
                </a>
              </div>
              <div className=" items-center p-4 ">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/dyyrul"
                >
                  <FaGithub
                    size={18}
                    className="mx-auto  text-slate-100 transition duration-300 hover:-translate-y-1 hover:text-orange-500"
                  />
                </a>
              </div>
            </div>
            <p className="mb-2 text-xs text-slate-300  md:text-sm">
              &#169;2023 <span className="font-medium">Hadi </span>Made with
              ❤‍🔥 by dyy_rul07 with{" "}
              <span className="font-medium text-cyan-100">reactjs</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
